<template>
  <div id="app" :class="appClass" :dir="direction">
    <NavigationBar />
    <main>
      <b-dialog
      v-if="shouldShowExpireUserMessage"
      role="alert"
      type="is-white"
      :canCancel='false'
      :message="$t('LogoutWarningText')"
      :confirmText="$t('LogoutWarningAction')"
      class="dialog-warning"
      data-test-id="logoutWarningMessage"
    />
      <router-view class="view"></router-view>
    </main>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import AuthEngine from '@/plugins/msal'
import NavigationBar from './components/NavigationBar.vue'
import { useAppStore } from '@/stores/app'
import { getEnvironmentBackgroundClass } from '@/utils/environmentClass'

const route = useRoute()
const { locale } = useI18n()
const store = useAppStore()

onMounted(() => {
  if (route.path.toLowerCase() !== '/callback') {
    AuthEngine.renewTokens().catch(() => {
      // Suppress the 'not logged in' error as we can illegitimately get that
      // when processing the callback url
    })
  }
})

const appClass = computed(() => {
  return getEnvironmentBackgroundClass(import.meta.env.VITE_ENV)
})

const direction = computed(() => {
  const currentLocale = (locale.value || '').toString().toLowerCase()
  return currentLocale.startsWith('he') ? 'rtl' : 'ltr'
})

const userMsToExpire = computed(() => store.getUserMsToExpire)

const shouldShowExpireUserMessage = computed(() => {
  let showMessage = false
  const remainingMsForLogoutWarning = 5 * 60 * 1000
  const msToLogoutWarning = (userMsToExpire.value || 0) - remainingMsForLogoutWarning
  if (userMsToExpire.value && msToLogoutWarning <= 0) {
    showMessage = true
  }
  return showMessage
})


</script>

<style lang="scss">
@use "@/assets/styles/_bulma-setup";
// Font Awesome SVG icon fixes for Buefy
.icon svg {
  fill: currentColor !important;
  width: 1em;
  height: 1em;
  vertical-align: middle;
}

.icon svg path {
  fill: inherit;
}

// Ensure proper alignment in buttons
.button .icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
